export default "__VITE_ASSET___h7NR5n___"